import { Injectable } from '@angular/core';

@Injectable()
export class AttrIndexService {

	countryNagCategoryName = 'COUNTRY';
	stateNagCategoryName = 'STATE';
	nagStateCateId = 3;

	nagStandardNameCol = 'stn_name';
	nagStandardIdCol = 'stn_id';

	nagAlternateNameCol = 'aln_name';

	constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/common-services/attr-index.service.ts